import Footer from '@/pages/home/components/Footer';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function LegalHeader() {
  const { t } = useTranslation();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background-50/90 backdrop-blur-xl border-b border-background-200/70">
      <div className="w-full px-4 md:px-10 lg:px-16">
        <div className="flex items-center justify-between h-[72px]">
          <Link to="/" className="flex items-center cursor-pointer">
            <img
              src="/img/logo-imagotipo.webp"
              alt="AIdeal Media"
              className="h-10 w-auto object-contain"
            />
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium text-primary-700 bg-primary-100 hover:bg-primary-200 transition-colors whitespace-nowrap"
          >
            <i className="ri-arrow-left-line"></i>
            {t('legal.back_to_home')}
          </Link>
        </div>
      </div>
    </header>
  );
}

function LegalContactBox() {
  const { t } = useTranslation();

  return (
    <div className="bg-background-100 rounded-lg p-5 border border-background-200/70 mt-8">
      <h3 className="font-heading text-base font-bold text-foreground-950 mb-2">
        {t('legal.contact_title')}
      </h3>
      <p className="text-foreground-700 leading-relaxed font-semibold">
        {t('legal.contact_entity')}
      </p>
      <p className="text-foreground-700 leading-relaxed mt-1">
        {t('legal.contact_email')}
      </p>
      <p className="text-foreground-700 leading-relaxed">
        {t('legal.contact_location')}
      </p>
    </div>
  );
}

export default function Terminos() {
  const { t } = useTranslation();

  const sections = [
    { titleKey: 'terms.s1_title', textKey: 'terms.s1_text' },
    { titleKey: 'terms.s2_title', textKey: 'terms.s2_text' },
    { titleKey: 'terms.s3_title', textKey: 'terms.s3_text' },
    { titleKey: 'terms.s4_title', textKey: 'terms.s4_text' },
    { titleKey: 'terms.s5_title', textKey: 'terms.s5_text' },
    { titleKey: 'terms.s6_title', textKey: 'terms.s6_text' },
  ];

  return (
    <main className="relative bg-background-50 text-foreground-900 font-body">
      <LegalHeader />

      {/* Header Banner */}
      <section className="relative pt-[72px] bg-gradient-to-br from-primary-800 via-primary-900 to-primary-950 overflow-hidden">
        <div className="absolute inset-0 grid-pattern opacity-10"></div>
        <div className="relative max-w-5xl mx-auto px-6 md:px-10 py-12 md:py-16">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/15 text-accent-300 text-xs font-semibold border border-accent-500/25">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-400"></span>
            {t('legal.badge')}
          </span>
          <h1 className="mt-5 font-heading text-3xl md:text-5xl font-bold text-background-50 leading-tight">
            {t('terms.title')}
          </h1>
          <p className="mt-3 text-background-200/80 text-sm md:text-base">
            {t('legal.subtitle_terms')}
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="relative py-10 md:py-14">
        <div className="max-w-4xl mx-auto px-6 md:px-10">
          <div className="prose prose-base md:prose-lg max-w-none text-foreground-800 space-y-8">

            {sections.map((section, idx) => (
              <div key={idx}>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-3">
                  {t(section.titleKey)}
                </h2>
                <p className="text-foreground-700 leading-relaxed">
                  {t(section.textKey)}
                </p>
              </div>
            ))}

            <LegalContactBox />

          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}